import React, { ChangeEvent } from 'react';
import { Button, useTheme } from '@mui/material';

export type ContinueButtonProps = {
    libelle?: string;
    onClick: (event: ChangeEvent<HTMLInputElement>) => void;
    disabled?: boolean;
};

export const ContinueButton: React.FunctionComponent<ContinueButtonProps> = function (props) {
    const { onClick = () => {}, libelle = 'Continuer', disabled = false } = props;

    const theme = useTheme();
    return (
        <Button
            data-testid="test-id-continueButton"
            variant="contained"
            color="primary"
            disabled={disabled}
            sx={{
                backgroundColor: theme.palette.primary.dark,
                width: '100%',
                marginTop: '30px',
                padding: '16px 24px 16px 24px',
                fontSize: '1rem',
                lineHeight: '1.5',
                borderRadius: '15px',
                transition: 'background-color ease-in-out 300ms',
                ':hover': {
                    backgroundColor: theme.palette.primary.main,
                },
            }}
            onClick={onClick}
        >
            {libelle}
        </Button>
    );
};
